import React, { Component } from "react";
import SimplePopup from "../../../../components/bases/popup/simplePopup";
import AddVideo from "../../../dialogs/addvideo/addvideo";
import EditVideo from "../../../dialogs/addvideo/editvideo.js";
import AssetSectionTitle from "./assetsectiontitle.js";
import AssetSectionItem from "./assetsectionItem.js";
import AddTranscription from "../../../dialogs/addtranscription/addtranscription.js";
import AddSTL from "../../../dialogs/addstl/addstl.js";
import AddSRT from "../../../dialogs/addsrt/addsrt.js";
import AddDocument from "../../../dialogs/adddocument/adddocument.js";
import DisplayTranscript from "./displaytranscript.js";
import DisplaySubtitle from "./displaytsubtitles.js";
import DisplayDocument from "./displaydocument.js";
import DisplaySequences from "./displaysequences.js";
import DisplayVideo from "./displayvideo.js";
import GraphVideo from "../../../dialogs/addvideo/graphvideo/graphvideo.js";
import EditTranscription from "../../../dialogs/addtranscription/edittranscription.js";

import {  UploadComponentRef} from "../../../../utils/globalprovider.js"
import { apiCreateSequences, apiCreateFromAsset, apiUpdateAsset,apiDeleteAsset, apiSearchAssetsFromProject, ApiUpdateAssetVideo, ApiDeleteAssetVideo, ApiGetVideoShortList } from "../../../../utils/apis.js"
import { convertTranscriptionScriptToSequences, convertTranscriptionScriptType0, convertTextFileToJson } from "../utils.js";
import { convertSRTtoOttoSubtitles, convertEBUDatasToSTL,convertSTLtoOttoSubtitles } from "./importstl.js";
import "./assetsmanager.css"
import { getAssetColorsByType } from "../../../../utils/colors.js";
import { V2_recfps } from "../../../../utils/timecodev2.js";
import AddJsonSubtitles from "../../../dialogs/addjsonsubtitles/addsjonsubtitles.js";

import { configurations_getDefaultParams } from "../../../../utils/configurations.js";
import { getCurrentProjectDatas } from "../../../../utils/software.js";

import { SearchVideoProgress } from "../../../../utils/videoutils.js";
import { checkSubtitle } from "../../../../utils/checksubtitles.js";

class AssetsManager extends React.Component
{

  
  constructor(props) 
  {
    super(props);
    this.validFiles  = ["wav","mp3","mp4","mpg","mpeg","mov","json","webm","stl","txt", "rtf", "pdf","wmv","srt"];
    this.videoFiles = ["mp4","mpg","mpeg","mov","webm","mp3","wav","wmv"];
    this.transcriptionFiles  = ["json","txt","rtf"]
    this.STLFiles  = ["stl"]
    this.SRTFiles  = ["srt"]
    this.documentFiles = ["pdf","docx"]
    this.state = 
    {

      current: {
        video: 0,
        originaltr: 0,
        correctedtr: 0,
        calculatedsubtitles: 0,
        correctedsubtitle: 0,
        finaltr: 0, 
        vo:0,                   
        sequences:0,
      },



      invalideFilePopup: false,
      invalideTranscriptionPopup: false,
      invalideSTLPopup: false,
      invalideSRTPopup: false,
      deletePopup: false,
      deleteAssetVideoPopup: false,
      displayAddVideo: false,
      displayAddTranscription: false,
      displayAddSTL: false,
      displayAddSRT: false,
      displayAddDocument: false,
      displayAddJsonSubtitles: false,
      displayEditTranscript: false,
      displayEditTranscript: false,
      displayEditVideo: false,
      displayGraphe: false,

      assetsListe : [],
      videosListe : [],
      displayViewTranscript: false,
      displayViewDocument: false,
      displayViewSequences: false,
      displayViewSubtitles: false,
      displayViewVideo: false,
      currentAsset:{},
      pjid: this.props.pjid,
      initialised: false,
    }
    this.exitAllPopup = this.exitAllPopup.bind(this)
    this.queryNewFile = this.queryNewFile.bind(this)
    this.OnAddVideoButton = this.OnAddVideoButton.bind(this)
    this.OnAddJsonSubtitlesButton = this.OnAddJsonSubtitlesButton.bind(this);
    this.onVideoDownloadDone = this.onVideoDownloadDone.bind(this);
    this.OnAddSTLButton = this.OnAddSTLButton.bind(this);
    this.onAddSRTButton = this.onAddSRTButton.bind(this);
    this.OnAddDocumentButton = this.OnAddDocumentButton.bind(this);
    this.OnAddTranscriptionButton = this.OnAddTranscriptionButton.bind(this);
    this.onAssetsDownloaded = this.onAssetsDownloaded.bind(this);
    this.onVideoListDownloaded = this.onVideoListDownloaded.bind(this);
    this.onDeleteAsset = this.onDeleteAsset.bind(this)
    this.onGraphe = this.onGraphe.bind(this)
    this.endDisplayGraph = this.endDisplayGraph.bind(this)
    this.onReallyDeleteAsset = this.onReallyDeleteAsset.bind(this)
    this.onReallyDeleteAssetVideo = this.onReallyDeleteAssetVideo.bind(this)
    this.reloadAllAssets = this.reloadAllAssets.bind(this)
    this.onViewAsset = this.onViewAsset.bind(this)
    this.onEditAsset = this.onEditAsset.bind(this)
    this.onDuplicateAsset = this.onDuplicateAsset.bind(this)
    this.onFinishView = this.onFinishView.bind(this)
    this.onFinishEdit = this.onFinishEdit.bind(this)
    this.onFinishEditVideo = this.onFinishEditVideo.bind(this)


    this.sequences_createsequences = this.sequences_createsequences.bind(this);
    this.sequences_createsequences_callback = this.sequences_createsequences_callback.bind(this)

    this.listeSections =  
    [
      {
          title:{fr:"Vidéos",en:"Videos"},
          type: 3,
      },
    
    {
          title:{fr:"Transcriptions originales",en:"Original Transcripts"},
          type: 1,
    },
    {
          title:{fr:"Transcriptions corrigées",en:"Corrected Transcripts"},
          type: 2,
    },
    {
          title:{fr:"Sous-titres calculés/Importés",en:"Imported/Computed subtitles"},
          type: 4,
    },
    {
          title:{fr:"Sous-titres corrigés",en:"Corrected Subtitles"},
          type: 5,
    },
    {
        title:{fr:"Transcription des sous-titres corrigés",en:"Transcription from Corrected Subtitles"},
        type: 6,
    },
    {
        title:{fr:"Voice Over - Audio Description",en:"Voice Over - Audio Description"},
        type: 7,
    },
    {
        title:{fr:"Séquences",en:"Séquences"},
        type: 8,
    },
    {
        title:{fr:"Documents",en:"Documents"},
        type: 9,
    },

    ]


    this.mustRefreshAssetsList = false;
}
  
  getCurrentValueByType(type)
  {
      switch (type)
      {
        case 1:
        case 2:
        return {
            v1: this.state.current.originaltr, colorv1: getAssetColorsByType("trjson"),
            v2: this.state.current.correctedtr, colorv2: getAssetColorsByType("newtrjson"),

            };
        case 4:
        case 5:
        return {
            v1: this.state.current.calculatedsubtitles, colorv1: getAssetColorsByType("st"),
            v2: this.state.current.correctedsubtitle, colorv2: getAssetColorsByType("oldst"),
            };
            
        case 3: 
            
        return {
            
            v1: this.state.current.video, colorv1: getAssetColorsByType("video"),
            v2: 0, colorv2: getAssetColorsByType("video"),
            };

        case 6: 
        return {
            v1: this.state.current.finaltr, colorv1: getAssetColorsByType("finaltrjson"),
            v2: 0, colorv2: getAssetColorsByType("finaltrjson"),
            };
        case 7: 
        return {
            v1: this.state.current.vo, colorv1: getAssetColorsByType("voiceover"),
            v2: 0, colorv2: getAssetColorsByType("voiceover"),
            };
        case 8: 
        return {
            v1: this.state.current.sequences, colorv1: getAssetColorsByType("sequences"),
            v2: 0, colorv2: getAssetColorsByType("sequences"),
            };

        default: 
          return {v1:0,v2:0};
    
      }
  }


  exitAllPopup()
  {
      this.setState (
        {
          invalideFilePopup: false,
          invalideTranscriptionPopup: false,
          invalideSTLPopup: false,
          invalideSRTPopup: false,
          deletePopup: false,
          deleteAssetVideoPopup: false,

        }
      )
  }

  removeExtension(filename) 
  {
    const index = filename.indexOf(".");
    if (index === -1) return filename;
    return filename.split('.').slice(0, -1).join('.');
  }

  getFileExtension(file)
  {
      const filename = file.name; // Get the file name
      const index = filename.indexOf(".");
      if (index === -1) return "";

      const fileExtension = filename.split(".").pop().toLowerCase(); // Extract the file extension
      return fileExtension;

  }

  onAssetsDownloaded(datas)
  {

    var videoliste = [];
    for (var i=0; i < datas.length; i++)
      if (datas[i].astype == 3) videoliste.push({viid:datas[i].asviid});

    if (videoliste.length === 0)
    {
      this.mustRefreshAssetsList = false;
      this.setState({assetsListe: datas, videosListe: [], pjid: this.state.pjid})
      if (this.props.assetsDownloaded)
        this.props.assetsDownloaded(datas);
      if (this.props.onChange !== null)
        this.props.onChange(datas)
      return;
    }
    this.tempAssetsList = datas;
    
    ApiGetVideoShortList(videoliste,this.onVideoListDownloaded)
  }

  onVideoListDownloaded(datas)
  {

    //






    this.mustRefreshAssetsList = false;
    for (var i=0; i < datas.length; i++)
    {
      var video = datas[i];
      this.mustRefreshAssetsList = SearchVideoProgress(video);
    }
    this.setState({assetsListe: this.tempAssetsList, videosListe: datas, pjid: this.state.pjid})

    
    if (this.props.assetsDownloaded)
      this.props.assetsDownloaded(this.tempAssetsList);
    if (this.props.onChange !== null)
      this.props.onChange(this.tempAssetsList)

  }

  setNewProject(pjid)
  {
      this.setState({pjid:pjid});
      apiSearchAssetsFromProject({pjid: pjid}, this.onAssetsDownloaded);
  }

  setNewCurrent(current)
  {
    this.setState({current: current});
  }
  getCurrent()
  {
    return this.state.current;
  }


  reloadAllAssets()
  {
    apiSearchAssetsFromProject({pjid: this.state.pjid}, this.onAssetsDownloaded);
  }

  startIntervalAutoRedraw() 
  {
    this.intervalIdAutoRedraw = setInterval(() => {

      if (this.mustRefreshAssetsList)
        this.reloadAllAssets()
      
    }, 2000); 
  }
  
  stopIntervalAutoRedraw()
  {
    clearInterval(this.intervalIdAutoRedraw);
  }




  componentWillUnmount()
  {
    this.stopIntervalAutoRedraw();
  }

  componentDidMount()
  {




    if (this.state.initialised) return;
    this.setState({initialised:true})
    this.reloadAllAssets()


      this.fileInput = document.createElement('input');
      this.fileInput.type = 'file';
      this.fileInput.style.display = 'none';    



      this.fileInput.addEventListener('change', (event) => {
            if (event.target.files.length > 0) 
                {
                    
                    var dropfile = event.target.files[0];
                    
                    this.AddNewFile(dropfile)
                    event.target.value = "";
                }
              
        });      

      const dropZone = document.getElementById('dropZoneAssets');


      // Empêche le comportement par défaut pour le drag-and-drop
      ['mousedown','dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
        dropZone.addEventListener(eventName, e => e.preventDefault());
      });    

      // Ajoute les styles au survol
      ['dragenter', 'dragover'].forEach(eventName => {
      dropZone.addEventListener(eventName, () => 
        {
          dropZone.style.borderColor = 'green';
          dropZone.style.borderWidth = '2px';
          dropZone.style.borderStyle = "solid";
          
        }
        );
          });    


      ['dragleave'].forEach(eventName => {
        dropZone.addEventListener(eventName, () => 
          {
            dropZone.style.borderColor = 'transparent';
            dropZone.style.borderWidth = '2px';
            dropZone.style.borderStyle = "solid";
          }
          );
            });    
  
        dropZone.addEventListener('drop', e => {
          const files = e.dataTransfer.files; // Récupère les fichiers
          dropZone.style.borderWidth = '0px'
          if (files.length > 0) 
            {
                
                var dropfile = files[0];

                this.AddNewFile(dropfile)
              }

        });

        this.startIntervalAutoRedraw();

  }

  queryNewFile()
  {
     
      this.fileInput.click();
  }

  AddNewFile(newfile)
  {
    
    const extension = this.getFileExtension (newfile)
    
    
    if ((this.validFiles.length != 0) && ((extension ==="") || (!this.validFiles.includes(extension)) ))
      this.setState({invalideFilePopup:true})
    else
    {
        if (this.videoFiles.includes(extension))
          this.AddNewVideo(newfile)
        else
          if (this.transcriptionFiles.includes(extension))
            this.addNewTranscription(newfile, extension)
          else
             if (this.STLFiles.includes(extension))
                this.addNewSTL(newfile, extension)
              else 
              if (this.SRTFiles.includes(extension))
                  this.addNewSRT(newfile, extension)
                else
                  if (this.documentFiles.includes(extension))
                    this.addNewDocument(newfile,extension)
    }

  }

  AddNewVideo(newfile)
  {
      this.setState({
        displayAddVideo:true,
        videofile: newfile,
      });

  }
  addNewDocument(newfile, extension)
  { 
    
      

      this.setState(
        {displayAddDocument: true,
        documentFileName: newfile.name,
        documentDatas: newfile,
        });
  }
  addNewSTL(newfile, extension)
  {
    
    const reader = new FileReader();
    // Convert the file to a Base64 string
    reader.onload = (e) => {
        const stlbinarydata = e.target.result;
        const jsonstl = convertEBUDatasToSTL(stlbinarydata);

        if (!jsonstl.success)
          this.setState({invalideSTLPopup:true});
        else
        {

            if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

            this.setState(
              {displayAddSTL: true,
              STLFileName: newfile.name,
              STLName: newfile.name,
              STLDatas: jsonstl,
              });
          
        }
    };        
    reader.readAsArrayBuffer(newfile);

  }

  addNewSRT(newfile, extension)
  {
    
    const reader = new FileReader();
    // Convert the file to a Base64 string
    reader.onload = (e) => {
        const srtString = e.target.result;
        const jsonstr = convertSRTtoOttoSubtitles(srtString);

        if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

        this.setState(
          {displayAddSRT: true,
          STLFileName: newfile.name,
          STLName: newfile.name,
          STLDatas: jsonstr,
          });
          
        reader.onerror = (event) =>
        {
          this.setState({invalideSRTPopup:true});
        };


    };        
    reader.readAsText(newfile,"UTF-8");

  }


  addNewTranscription(newfile, extension)
  {

    
    const reader = new FileReader();
    // Convert the file to a Base64 string
    reader.onload = (e) => {
        

       // on regarde si la transcription est valide


        const jsonfile = e.target.result;


        if (extension === "rtf")
        {
          
          const jsondatas = convertTextFileToJson(jsonfile, true);
          
          const memoryFile = new File([JSON.stringify(jsondatas)], newfile.name, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });

          if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

          this.setState(
            {displayAddTranscription: true,
            transcriptionFile: memoryFile,
            transcriptionType: 0,
            transcriptionData: jsondatas,
            }
          )

          return;
          
        }


        if (extension === "txt")
        {
          
          const jsondatas = convertTextFileToJson(jsonfile, false);
          
          const memoryFile = new File([JSON.stringify(jsondatas)], newfile.name, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });

          if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

          this.setState(
            {displayAddTranscription: true,
            transcriptionFile: memoryFile,
            transcriptionType: 0,
            transcriptionData: jsondatas,
            }
          )

          return;

        }


        if (extension === 'json') 
          {
            try
            {
              
              
              const jsondatas  = JSON.parse (jsonfile)

              if (jsondatas.subtitles && Array.isArray(jsondatas.subtitles))
              {

                if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

                this.setState(
                  {displayAddJsonSubtitles: true,
                  JsonFileName: newfile.name,
                  JsonTitle: this.removeExtension(newfile.name),
                  JSonDatas: jsondatas,
                  
                  });
                return;
              }


              if ( (jsondatas.transcription) && Array.isArray(jsondatas.transcription))  
              {
                // on regarde si on a une video
                jsondatas.viid = 0;
                //$$$

                  var num=25;
                  var den=1;
                  var dropframe=0;

                  if (this.state.videosListe.length !== 0)
                  {
                    dropframe = this.state.videosListe[0].vidropframe;
                    num = this.state.videosListe[0].vinum;
                    den = this.state.videosListe[0].viden;

                  }




                if (this.state.videosListe.length)
                {
                  
                  jsondatas.viid = this.state.videosListe[0].viid;
                }
                if ("stparams" in jsondatas) delete jsondatas.stparams;
                if ("cplist" in jsondatas) delete jsondatas.cplist;
                if ("stats" in jsondatas) delete jsondatas.stats;


                const memoryFile = new File(
                  [JSON.stringify(jsondatas)], 
                  newfile.name, 
                {
                type: "application/json", // MIME type for JSON
                lastModified: new Date().getTime() // Timestamp for the file
                });


                if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)


                  
                  var memorySequenceFileJson = convertTranscriptionScriptToSequences(jsondatas,this.state.pjid, num,den,dropframe);
                  console.log("sequences récupérées : ",memorySequenceFileJson)

                  var memorySequenceFile = null;
                  if (memorySequenceFileJson)
                  {
                    
                    memorySequenceFile = new File(
                      [JSON.stringify(
                        memorySequenceFileJson)
                        ], 
                      newfile.name, 
                    {
                    type: "application/json", // MIME type for JSON
                    lastModified: new Date().getTime() // Timestamp for the file
                    });

                  }
                  else
                    memorySequenceFileJson = {};

                  console.log("sequence file ", memorySequenceFile)

                  
                  this.setState(
                    {displayAddTranscription: true,
                    transcriptionFile: memoryFile,
                    sequenceFile: memorySequenceFile,
                    transcriptionType: 0,
                    transcriptionData: jsondatas,
                    sequenceData: memorySequenceFileJson,
                    asfilesequence: this.generateUUID(),
                    })

                return;
              }

              if ( (jsondatas.words && Array.isArray(jsondatas.words)) || (jsondatas.segments && Array.isArray(jsondatas.segments)) )
              {
                  var num=25;
                  var den=1;
                  var dropframe=0;

                  if (this.state.videosListe.length !== 0)
                  {
                    dropframe = this.state.videosListe[0].vidropframe;
                    num = this.state.videosListe[0].vinum;
                    den = this.state.videosListe[0].viden;

                  }


                  
                  
                  const memoryFile = new File(
                    [JSON.stringify(
                      convertTranscriptionScriptType0(jsondatas,
                      num,den,dropframe))], 
                    newfile.name, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });



                  console.log ("test si il y des sequences recuperables")
                  const memorySequenceFileJson = convertTranscriptionScriptToSequences(jsondatas,this.state.pjid, num,den,dropframe);

                  
                  var memorySequenceFile = null;
                  if (memorySequenceFileJson)
                  {
                    
                    memorySequenceFile = new File(
                      [JSON.stringify(
                        memorySequenceFileJson)
                        ], 
                      newfile.name, 
                    {
                    type: "application/json", // MIME type for JSON
                    lastModified: new Date().getTime() // Timestamp for the file
                    });

                  }


                  if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

                  this.setState(
                    {displayAddTranscription: true,
                    transcriptionFile: memoryFile,
                    sequenceFile: memorySequenceFile,
                    transcriptionType: 0,
                    transcriptionData: jsondatas,
                    sequenceData: memorySequenceFileJson,
                    asfilesequence: this.generateUUID(),
                    }
                  )
              }
                
              return;
            }
            catch (e)
            {
              // pour l'instant on fait rien
              console.log(e)
              
            }
          }
              

          this.setState({invalideTranscriptionPopup:true});
    };        
    reader.readAsText(newfile);

  }

  OnAddJsonSubtitlesButton(button,formulaire)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false);

    if (button === "ok")
    {
      

          if (!("params" in formulaire.JsonDatas))
            formulaire.JsonDatas.params  = configurations_getDefaultParams();

          const memoryFile = new File([JSON.stringify(formulaire.JsonDatas)], formulaire.filename, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });

          formulaire.uploadfile = memoryFile;
          formulaire.asframerate = 25.0;
          formulaire.asnum = 25;
          formulaire.asden = 1;
          formulaire.asviid = 0;
          formulaire.asdropframe = 0;
          formulaire.astimecode = "00:00:00:00";
          formulaire.ascoid = getCurrentProjectDatas().pjconfig;

          if (this.state.videosListe.length !== 0)
          {
            formulaire.asviid = this.state.videosListe[0].viid;
            formulaire.asframerate = this.state.videosListe[0].viframerate;
            formulaire.asdropframe = this.state.videosListe[0].vidropframe;
            // formulaire.astimecode = this.state.videosListe[0].vitimecode;
            formulaire.asnum = this.state.videosListe[0].vinum;
            formulaire.asden = this.state.videosListe[0].viden;

          }

          // on recherche de premier time code
          



          formulaire.type = 4; // original subtitles
          UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 5,this.reloadAllAssets); 

    }

    this.setState({displayAddJsonSubtitles:false});
  }

  OnAddDocumentButton(button, formulaire)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false);
    if (button === "ok")
    {
          UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 6, this.onVideoDownloadDone);    
    }
    this.setState({displayAddDocument:false, documentDatas: null});

  }

  onAddSRTButton(button, formulaire)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false);

    if (button === "ok")
    {
      
      const ottosubtitles  = formulaire.STLDatas;

      

      if (ottosubtitles != null)
      {
          ottosubtitles.pjid = this.state.pjid;
          
          var framerate = V2_recfps(25,1);
          var num=25;
          var den=1;
          var dropframe=0;
          var timecode="00:00:00:00"


          ottosubtitles.subtitles.forEach( (st, index)=>{

              var stp = null;
              var sts = null;

              if (index !==0) stp = ottosubtitles.subtitles[index-1];
              if (index < (ottosubtitles.subtitles-1)) sts = ottosubtitles.subtitles[index + 1];
              checkSubtitle(stp,st,sts,ottosubtitles.params,framerate,num,den,dropframe,timecode,null);
          })
          const memoryFile = new File([JSON.stringify(ottosubtitles)], formulaire.filename, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });

          formulaire.uploadfile = memoryFile;
          formulaire.asframerate = framerate;
          formulaire.asnum = num;
          formulaire.asden = den;
          formulaire.asviid = 0;
          formulaire.asdropframe = dropframe;
          formulaire.astimecode = timecode;
          formulaire.ascoid = getCurrentProjectDatas().pjconfig;

          if (this.state.videosListe.length !== 0)
          {
            formulaire.asviid = this.state.videosListe[0].viid;
            formulaire.asframerate = this.state.videosListe[0].viframerate;
            formulaire.asdropframe = this.state.videosListe[0].vidropframe;
            // formulaire.astimecode = this.state.videosListe[0].vitimecode;
            formulaire.asnum = this.state.videosListe[0].vinum;
            formulaire.asden = this.state.videosListe[0].viden;


          }
          console.log("formulaire = ", formulaire)

          formulaire.type = 4; // original subtitles
          
          UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 5,this.reloadAllAssets); 

      }
  }
    this.setState({displayAddSRT:false});
    
  }

  OnAddSTLButton(button, formulaire)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false);

    if (button === "ok")
    {
      
      const ottosubtitles  = convertSTLtoOttoSubtitles(formulaire.STLDatas);

      if (ottosubtitles != null)
      {
          ottosubtitles.pjid = this.state.pjid;
          
          var framerate = V2_recfps(formulaire.STLDatas.num,formulaire.STLDatas.den);
          var num=formulaire.STLDatas.num;
          var den=formulaire.STLDatas.den;
          var dropframe=formulaire.STLDatas.dropframe;
          var timecode="00:00:00:00"


          ottosubtitles.subtitles.forEach( (st, index)=>{

              var stp = null;
              var sts = null;

              if (index !==0) stp = ottosubtitles.subtitles[index-1];
              if (index < (ottosubtitles.subtitles-1)) sts = ottosubtitles.subtitles[index + 1];
              checkSubtitle(stp,st,sts,ottosubtitles.params,framerate,num,den,dropframe,timecode,null);
          })
          const memoryFile = new File([JSON.stringify(ottosubtitles)], formulaire.filename, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });

          formulaire.uploadfile = memoryFile;
          formulaire.asframerate = framerate;
          formulaire.asnum = num;
          formulaire.asden = den;
          formulaire.asviid = 0;
          formulaire.asdropframe = dropframe;
          formulaire.astimecode = timecode;
          formulaire.ascoid = getCurrentProjectDatas().pjconfig;

          if (this.state.videosListe.length !== 0)
          {
            formulaire.asviid = this.state.videosListe[0].viid;
            formulaire.asframerate = this.state.videosListe[0].viframerate;
            formulaire.asdropframe = this.state.videosListe[0].vidropframe;
            // formulaire.astimecode = this.state.videosListe[0].vitimecode;
            formulaire.asnum = this.state.videosListe[0].vinum;
            formulaire.asden = this.state.videosListe[0].viden;


          }

          // on recherche de premier time code
          



          formulaire.type = 4; // original subtitles
           
          
          UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 5,this.reloadAllAssets); 

      }
  }
    this.setState({displayAddSTL:false});
  }


sequences_createsequences()
{
  console.log ("write sequence file")
  var viid = 0;

  for (var i=0; i < this.state.assetsListe.length; i++)
  {
      var oneasset = this.state.assetsListe[i];
      if (oneasset.astype === 3)
        viid = oneasset.asviid;
  }
  if (viid === 0) return; // pas de video trouvé
  const datas = {
    viid: viid,
    pjid: this.state.pjid,
    ascreatedate: this.getCurrentDate(),
    asupdatedate: this.getCurrentDate(),
    asfile: this.state.asfilesequence,
    asext: "json",
  }
  
  
  apiCreateSequences(datas, this.sequences_createsequences_callback);
}
sequences_createsequences_callback(datas)
{
    
    if (datas.ret)
    {
      this.reloadAllAssets();

      if ((UploadComponentRef) && (UploadComponentRef.current))
      {
        const formulaire = {
          asid: datas.asid,
          aspjid: this.state.pjid,
          astype: 8,
          uploadfile: this.state.sequenceFile,
          filenamedest: this.state.asfilesequence + ".json",
          filenamesource: this.state.asfilesequence,
          asupdatedate: this.getCurrentDate(),
          
        }
        
        UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,null);
      }


    }
}

  
  OnAddTranscriptionButton(button, formulaire)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false)
    this.setState({displayAddTranscription:false});



    if (button === "ok")       
    {





      formulaire.type = 1;

      formulaire.viid = 0;
      formulaire.framerate = 25;
      formulaire.dropframe = 0;
      formulaire.timecode = "00:00:00:00";
      formulaire.num = 25;
      formulaire.den = 1;
      formulaire.ascoid = getCurrentProjectDatas().pjconfig;

      if (this.state.videosListe.length !== 0)
      {
        formulaire.viid = this.state.videosListe[0].viid;
        formulaire.framerate = this.state.videosListe[0].viframerate;
        formulaire.dropframe = this.state.videosListe[0].vidropframe;
        formulaire.timecode = this.state.videosListe[0].vitimecode;
        formulaire.num = this.state.videosListe[0].vinum;
        formulaire.den = this.state.videosListe[0].viden;

      }


      
      UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 1,this.reloadAllAssets);    

      if (this.state.sequenceFile)
      {
          this.sequences_createsequences();
      }
      else
          console.log("pas de sequence file", this.state.sequenceFile)


      
    }   

  }

  OnAddVideoButton(button, formulaire)
  {
    
    this.setState({displayAddVideo:false});
    
    if (button === "ok")
    {
        UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 0, this.onVideoDownloadDone);    
        
    }

  }

  onVideoDownloadDone(datas)
  {
      
      this.reloadAllAssets();
      
  }

  onDuplicateAsset(datas)
  {

        var newtype = 2;
        if ((datas.astype === 4) || (datas.astype === 5))  newtype = 5;
        if (datas.astype === 8)   newtype = 8;
        if (datas.astype === 9)   newtype = 9;
        var datas  = 
        {
          asid: 0,
          aspjid: this.state.pjid,
          astype: newtype, // transcription corrigée
          asviid: datas.asviid,
          asoriid: datas.asid, // transcription originale
          astitle: datas.astitle,
          asfile: this.generateUUID(),
          originalfile: datas.asfile,
          aslang: datas.aslang,
          asext: datas.asext,
          assubtype: datas.assubtype,
          ascreatedate: this.getCurrentDate(),
          asupdatedate: this.getCurrentDate(),
          asframerate: datas.asframerate,
          asnum: datas.asnum,
          asden: datas.asden,
          asdropframe: datas.asdropframe,
          astimecode: datas.astimecode,
          ascoid: datas.ascoid,
          
        }

        if (newtype === 9) datas.asoriid = 0; // pas de parent
        
        apiCreateFromAsset(datas, this.reloadAllAssets)

  }

  onDeleteAsset(datas)
  {

      
    if (datas.astype === 3)
    {

      var text =
      {
        fr:"Voulez vous vraiement supprimer cette vidéo de ce projet. (Si cette vidéo n'est plus utilisée dans aucun projet, elle sera supprimée) :  "+datas.astitle,
        en:"Are you sure you want to remove this video from this project? (If this video is no longer used in any project, it will be deleted) : "+ datas.astitle,
      }

      this.setState({deleteAssetVideoPopup: true, currentAsset: datas, popupText: text});
      return;
    }



      var text =
      {
        fr:"Voulez vous vraiement supprimer la transcription "+datas.astitle,
        en:"Do you really want to delete transcription : "+ datas.astitle,
      }

      if ((datas.astype === 4) || (datas.astype ===5))
        text =
            {
              fr:"Voulez vous vraiement supprimer les sous-titres "+datas.astitle,
              en:"Do you really want to delete subtitles : "+ datas.astitle,
            }

      if (datas.astype === 8)
        text =
            {
              fr:"Voulez vous vraiement supprimer les séquences "+datas.astitle,
              en:"Do you really want to delete sequences : "+ datas.astitle,
            }

      if (datas.astype === 9)
        text =
            {
              fr:"Voulez vous vraiement supprimer le document "+datas.astitle,
              en:"Do you really want to delete the document : "+ datas.astitle,
            }

      this.setState({deletePopup: true, currentAsset: datas, popupText: text});
  }

  onReallyDeleteAssetVideo()
  {
    this.exitAllPopup();
    var formulaire  =
    {
      asid: this.state.currentAsset.asid,
      viid: this.state.currentAsset.asviid,
    }
    ApiDeleteAssetVideo(formulaire, this.reloadAllAssets)
  }

  onReallyDeleteAsset()
  {
      this.exitAllPopup();
      var formulaire  =
      {
        asid: this.state.currentAsset.asid,
        astype: this.state.currentAsset.astype,
        asfile: this.state.currentAsset.asfile,
        asext: this.state.currentAsset.asext,
      }

      apiDeleteAsset(formulaire, this.reloadAllAssets)
  }


  endDisplayGraph()
  { 
    this.setState({displayGraphe:false});
    this.mustRefreshAssetsList = true;

  }
  onGraphe(datas)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)
    if (this.props.setCancelKey) this.props.setCancelKey(true)
    this.setState({displayGraphe:true, currentAsset: datas});
    return;
      
  }
  

  onEditAsset(datas)
  {
    var orititle = "";
    if ( (datas.astype === 2) || (datas.astype === 4) || (datas.astype === 5) || (datas.astype === 8))
    {
        for (var i=0; i < this.state.assetsListe.length; i++)
        {
            if (this.state.assetsListe[i].asid === datas.asoriid)
            {
              orititle = this.state.assetsListe[i].astitle;
              break;
            }
        }
    }
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(true)

    if (this.props.setCancelKey) this.props.setCancelKey(true)

    if (datas.astype===3)
    {
      this.setState({displayEditVideo:true,orititle: orititle,
        currentAsset: datas,
      });
      return;
      
    }

    if (datas.astype === 9)
    {
      
      this.setState({displayEditDocument:true,orititle: orititle,
        currentAsset: datas,
      });
      return;

    }

    this.setState({displayEditTranscript:true,orititle: orititle,
      currentAsset: datas,
    });

  }
  onViewAsset(datas)
  {
    
    

    if (this.props.setCancelKey)
      this.props.setCancelKey(true)

    if ((datas.astype === 1) || (datas.astype === 2) || (datas.astype === 1))
      this.setState({displayViewTranscript:true,
        currentAsset: datas,
      });

    if (datas.astype === 3) 
        this.setState({displayViewVideo:true,
          currentAsset: datas,
        });
    if ((datas.astype === 4) || (datas.astype === 5))
        this.setState({displayViewSubtitles:true,
          currentAsset: datas,
        });

    if (datas.astype === 8)
      this.setState({displayViewSequences: true, currentAsset: datas})

    if (datas.astype === 9)
      this.setState({displayViewDocument: true, currentAsset: datas})
  }

  onFinishView(datas)
  {
    if (this.props.setCancelKey)
      this.props.setCancelKey(false)
    this.setState({displayViewTranscript:false, 
      displayViewVideo: false, 
      displayViewSubtitles: false, 
      displayViewDocument:false,
      displayViewSequences: false,
      currentAsset: {}, deletePopup: false,
    });
  }

  onFinishEditVideo(button, datas)
  {
    if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false);
    if (button === "ok")
    {
      


      ApiUpdateAssetVideo(
        {
        asid: datas.asid,
        viid: datas.viid,
        title: datas.title,
        lang1: datas.audio1lang,
        lang2: datas.audio2lang,

        searchdata: -1,
        conv: datas.convert?-1:0,
        cp: datas.cp?-1:0,
        audio: datas.audio?-1:0,
        transcription: datas.transcription?-1:0,
        texts: datas.texts?-1:0,
        },
        this.reloadAllAssets
      )
    }
    if (this.props.setCancelKey)
      this.props.setCancelKey(false)

    this.setState({displayEditTranscript:false, displayEditVideo: false, displayEditDocument: false, 
      currentAsset: {}, deletePopup: false,
    });


  }

  onFinishEdit (button, datas)
  {
      
      if (this.props.onCancelKeyboardEvent) this.props.onCancelKeyboardEvent(false)
      if (button === "ok")
      {

    
        apiUpdateAsset(
          {asid: datas.id,
           astype: datas.type,
           astitle: datas.title,
           aslang: datas.language,
          }, 
          this.reloadAllAssets
        )
      }
      if (this.props.setCancelKey)
        this.props.setCancelKey(false)
      this.setState({displayEditTranscript:false, displayEditVideo: false, displayEditDocument: false,
        currentAsset: {}, deletePopup: false,
      });
    }


    getCurrentDate = () => {
      const today = new Date();
    
      const year = today.getFullYear(); // Année AAAA
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
      const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
    
      return `${year}/${month}/${day}`;
    };
    generateUUID() 
  {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    array[6] = (array[6] & 0x0f) | 0x40; // Version 4
    array[8] = (array[8] & 0x3f) | 0x80; // Variant 1

    return [...array].map((byte, index) => {
        const hex = byte.toString(16).padStart(2, '0');
        return ([4, 6, 8, 10].includes(index) ? '-' : '') + hex;
    }).join('');
  }



  render()
  {




    var allWindows  = [];

    if (this.state.displayAddVideo)
      allWindows.push(<AddVideo  
        pjid = {this.props.pjid} assetsList = {this.state.assetsListe} display = {this.state.displayAddVideo} onButton ={this.OnAddVideoButton} videofile={this.state.videofile} zindex={10} />)


    if (this.state.displayGraphe)
    {
      allWindows.push(
      <GraphVideo display = {this.state.displayGraphe} 
        viid = {this.state.currentAsset.asviid}
        zindex = {8}
        onButton={this.endDisplayGraph}/>
      )

    }

    if (this.state.displayAddJsonSubtitles)
        allWindows.push(<AddJsonSubtitles display = {this.state.displayAddJsonSubtitles} 
        onButton ={this.OnAddJsonSubtitlesButton} 
        title={this.state.JsonTitle}
        filename={this.state.JsonFileName}
        JsonDatas={this.state.JSonDatas}   
          />)



    if (this.state.displayAddTranscription)
        allWindows.push(<AddTranscription display = {this.state.displayAddTranscription} 
        onButton ={this.OnAddTranscriptionButton} 
        transcriptionFile={this.state.transcriptionFile}
        transcriptionType={this.state.transcriptionType}
        transcriptionData={this.state.transcriptionData}     />)



    if (this.state.displayAddSTL)
        allWindows.push(<AddSTL display = {this.state.displayAddSTL} zindex={10}
        onButton ={this.OnAddSTLButton}
        STLName={this.state.STLName} 
        STLFile={this.state.STLFileName}
        STLDatas={this.state.STLDatas}     />)

    if (this.state.displayAddSRT)
        allWindows.push(<AddSRT display = {this.state.displayAddSRT} zindex={10}
        onButton ={this.onAddSRTButton}
        STLName={this.state.STLName} 
        STLFile={this.state.STLFileName}
        STLDatas={this.state.STLDatas}     />)


    if (this.state.displayAddDocument)
        allWindows.push(<AddDocument display = {this.state.displayAddDocument} zindex={10}
        onButton ={this.OnAddDocumentButton}
        documentFileName = {this.state.documentFileName} 
        documentDatas={this.state.documentDatas}     />)

    if (this.state.displayEditTranscript)
      {
        
        allWindows.push(
          <EditTranscription display = {this.state.displayEditTranscript} 
          onButton ={this.onFinishEdit} 
          asset = {this.state.currentAsset}
          orititle = {this.state.orititle}
          startposition =  "center"
          zindex={4}
          />
        )
      }
      if (this.state.displayEditDocument)
        allWindows.push(<AddDocument edit={true} 
          display = {this.state.displayEditDocument} 
          zindex={10}
          onButton ={this.onFinishEdit}
          asset = {this.state.currentAsset}
          startposition =  "center"
            />)

  
      if (this.state.displayEditVideo)
        {
          
          allWindows.push(
            <EditVideo display = {this.state.displayEditVideo} 
            onButton ={this.onFinishEditVideo} 
            asset = {this.state.currentAsset}
            orititle = {this.state.orititle}
            startposition ="right"
            zindex = {4}
            />
          )
        }

    if (this.state.displayViewSubtitles)
    {
      allWindows.push(
        <DisplaySubtitle display = {this.state.displayViewSubtitles} 
        onButton ={this.onFinishView} 
        asset = {this.state.currentAsset}
        startposition =  "right"
        />
      )

    }
          

    if (this.state.displayViewDocument)
    {
      
      allWindows.push(
        <DisplayDocument display = {this.state.displayViewDocument} 
        onButton ={this.onFinishView} 
        asset = {this.state.currentAsset}
        startposition =  "right"
        />
      )
    }

    if (this.state.displayViewSequences)
    {
      
      allWindows.push(
        <DisplaySequences display = {this.state.displayViewSequences} 
        onButton ={this.onFinishView} 
        asset = {this.state.currentAsset}
        startposition =  "right"
        />
      )
    }

    if (this.state.displayViewTranscript)
    {
      
      allWindows.push(
        <DisplayTranscript display = {this.state.displayViewTranscript} 
        onButton ={this.onFinishView} 
        asset = {this.state.currentAsset}
        startposition =  "right"
        />
      )
    }


    if (this.state.displayViewVideo)
      {
        
        allWindows.push(
          <DisplayVideo display = {this.state.displayViewVideo} 
          onButton ={this.onFinishView} 
          asset = {this.state.currentAsset}
          startposition =  "right"
          />
        )
      }
  


    var assetsListes = [];


    if (!this.props.tree)
    {

      this.listeSections.forEach(section => 
        {
          assetsListes.push (<AssetSectionTitle title={section.title} type={section.type}/>);
          if (Array.isArray(this.state.assetsListe)) 
          {
            this.state.assetsListe.forEach((oneasset, index) =>
            {
              
              if (section.type === oneasset.astype)
              {

                var parent = null;
                if ((section.type === 2) || (section.type === 4) || (section.type === 5) || (section.type ===  6) || (section.type ===  7) || (section.type ===  8))// transcription corrigée, sous-titre
                {

                  if (section.type === 8)
                    

                  for (var i=0; i < this.state.assetsListe.length; i++)
                  {
                      if (this.state.assetsListe[i].asid === oneasset.asoriid )
                      {
                          parent = this.state.assetsListe[i];
                          break;
                      }
                  }
                }


                const concat = ((oneasset.astype === 4) || (oneasset.astype === 5))
                assetsListes.push(
                  <AssetSectionItem
                    
                    index = {index}
                    asset = {oneasset}
                    videolist = {this.state.videosListe}
                    onDelete = {this.onDeleteAsset}
                    onEdit = {this.onEditAsset}
                    onView = {this.onViewAsset}
                    onDuplicate = {this.onDuplicateAsset}
                    onGraphe ={this.onGraphe}
                    parentasset = {parent}
                    nodelete = {this.props.nodelete}
                    selected = {( this.getCurrentValueByType(section.type)) }
                    mode = {this.props.mode}
                    onClick = {this.props.onClick}
                    concat = {concat}
                  />
                )
              }


            }
          
          );
        }
          
        });
      }
      else
      {
          // nouvelle affichage des assets en tree

          if (!Array.isArray(this.state.assetsListe))  return (<></>);

          this.state.assetsListe.forEach((oneasset, index) =>
          {
            oneasset.done = false; // 
          });

          var listeasset = [];
          this.state.assetsListe.forEach((oneasset, index) =>
          {
            oneasset.done = false; // 
            if (oneasset.astype == 3)
            {
              oneasset.done=true;
              listeasset.push (
              {
                  id: oneasset.asid,
                  viid: oneasset.asviid,
                  type: oneasset.astype,
                  ori:-1,
                  deca:0,
                  index: index,
                  parentasset:0,
              }

              )
            }
          });
          var thatsall=false;
          while (!thatsall)
          {
              thatsall=true;
              for (var i=0; i < this.state.assetsListe.length; i++)
              {
                var oneasset = this.state.assetsListe[i];
                if (!oneasset.done)
                {

                  var parentasset =  this.lookForAssetParent(oneasset,listeasset);
                  if (parentasset>=0)
                  {
                    oneasset.done = true;
                    this.insertAfterParent(parentasset, oneasset, listeasset,i, listeasset[parentasset].id);
                    thatsall=false;
                    break;
                  }


                  // on regarde si il a un parent video dans la liste
                  var parentvideo = this.lookForVideoParent(oneasset,listeasset);
                  if (parentvideo>=0)
                  {
                    oneasset.done = true;
                    this.insertAfterParent(parentvideo, oneasset, listeasset,i,listeasset[parentvideo].id);
                    thatsall=false;
                    break;
                  }
                }
              };
          }
          // on gère les pauvres petits orphelins
          this.state.assetsListe.forEach((oneasset, index) =>
          {
            if (!oneasset.done)
            {
              oneasset.done=true;
              listeasset.push (
              {
                  id: oneasset.asid,
                  viid: oneasset.asviid,
                  type: oneasset.astype,
                  ori:-1,
                  deca:0,
                  index:index,
                  parentasset: 0,
              }

              )
            }
          });
          

          this.displayListeAsset(listeasset);


          // création du diplay
          assetsListes.push(<><br/></>);
          for (var i=0; i < listeasset.length; i++)
          {
            var oneasset = this.state.assetsListe[listeasset[i].index];
            var parentasset = null;
            if (listeasset[i].parentasset > 0)
              parentasset = this.V2_GetAssetFromID(this.state.assetsListe,listeasset[i].parentasset);

            assetsListes.push(
              <AssetSectionItem
                
                index = {listeasset[i].index}
                asset = {oneasset}
                videolist = {this.state.videosListe}
                onDelete = {this.onDeleteAsset}
                onEdit = {this.onEditAsset}
                onView = {this.onViewAsset}
                onDuplicate = {this.onDuplicateAsset}
                onGraphe ={this.onGraphe}
                parentasset = {parentasset}
                selected = {( this.getCurrentValueByType(oneasset.astype)) }
                mode = {this.props.mode}
                onClick = {this.props.onClick}
                nodelete = {this.props.nodelete}
                tree = {true}
                deca = {listeasset[i].deca}

              />
            )
            

          }
          assetsListes.push(<><br/><br/><br/></>);

      }

    return  (
        <>
        {allWindows}
      <SimplePopup display={this.state.invalideFilePopup} 
            title="" text={{"fr":"Format de fichier non supporté.","en":"Unsupported format file."}} 
            onCancel={this.exitAllPopup}
          buttons ={[]}/>
      <SimplePopup display={this.state.invalideTranscriptionPopup} 
            title="" text={{"fr":"Format de transcription non supporté.","en":"Unsupported transcription file."}} 
            onCancel={this.exitAllPopup}
          buttons ={[]}/>

      <SimplePopup display={this.state.invalideSTLPopup} 
            title="" text={{"fr":"Format de fichier STL non supporté.","en":"Unsupported STL file."}} 
            onCancel={this.exitAllPopup}
          buttons ={[]}/>

      <SimplePopup display={this.state.invalideSRTPopup} 
            title="" text={{"fr":"Format de fichier SRT non supporté.","en":"Unsupported STL file."}} 
            onCancel={this.exitAllPopup}
          buttons ={[]}/>

      <SimplePopup display={this.state.deleteAssetVideoPopup} 
            title="" text={this.state.popupText} 
            onCancel={this.exitAllPopup}

            buttons ={
              [
                {text:{"fr":"Oui","en":"Yes"},onclick:this.onReallyDeleteAssetVideo},
                {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
              ]
            } 
        />



        <SimplePopup display={this.state.deletePopup} 
            title="" text={this.state.popupText} 
            onCancel={this.exitAllPopup}

            buttons ={
              [
                {text:{"fr":"Oui","en":"Yes"},onclick:this.onReallyDeleteAsset},
                {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
              ]
            } 
            />
          
        <div className="fullDivAssetsManager" id='dropZoneAssets' key={"assets"+this.state.pjid.toString()}>
          {assetsListes}

        </div>
        </>
    )



  }

  lookForAssetParent(asset,listeasset)
  {
    
    if (asset.asoriid < 1 ) return -1;
    for (var i=listeasset.length-1 ; i>=0 ; i--)
    {
      if (listeasset[i].id == asset.asoriid) return i;
    }
    return -1;

  }

  lookForVideoParent(asset,listeasset)
  {
    
    
    if ((asset.asoriid > 0 ) && (asset.astype !== 8))return -1;
    for (var i=0; i<listeasset.length; i++)
    {
      if ((listeasset[i].type==3) && (listeasset[i].viid == asset.asviid)) return i;
      if ((asset.astype ===8) && (listeasset[i].type===3) && (listeasset[i].viid == asset.asoriid)) return i;
    }
    return -1;
  }

  insertAfterParent(parent, oneasset, listeasset, index, parentid=0)
  {
        var newele =
        {
            id: oneasset.asid,
            viid: oneasset.asviid,
            type: oneasset.astype,
            ori: oneasset.asoriid,
            deca:listeasset[parent].deca + 1,
            index: index,
            parentasset: parentid,
        }

        var newparent = parent;

        while (
          (newparent < (listeasset.length-1)) && (listeasset[newparent+1].deca >= newele.deca)
        )
          newparent++;

        

        listeasset.splice (newparent+1,0, newele);


  }

    V2_GetAssetFromID(assets, id)
    {
      if (id < 1) return {asid:0};
      for (var i=0; i<assets.length; i++)
        if (assets[i].asid === id) return assets[i];
      return {asid:0};

    }
displayListeAsset(liste)
  {
      
      liste.forEach((onea, index) =>
      {
          
      });


  }


}
AssetsManager.defaultProps = 
{

    pjid: 0,
    AppTranscriptContainer: null,
    onClick: null,
    onChange: null,
    tree: false,
    nodelete: false,
    
}


export default AssetsManager;